// Vedlikeholds-logg + reservedel-katalog. Sporer materiellets tilstand (operativ/
// begrenset/ute av drift) via vedlikeholdshendelser, og lager-status for deler
// (lavt lager-varsel). Rene zod-skjema + hjelpere, i samme mønster som logistics.ts.
import { z } from 'zod';
// ── Reservedeler ─────────────────────────────────────────────────────────────
export const SparePartSchema = z.object({
    id: z.string().max(64),
    /** NATO Stock Number (valgfri). */
    nsn: z.string().max(32).optional(),
    name: z.string().max(200),
    qtyOnHand: z.number().int().min(0).default(0),
    /** Minimumsbeholdning før etterbestilling. */
    qtyMin: z.number().int().min(0).default(0),
    location: z.string().max(120).default(''),
});
export function parseSparePart(raw) {
    const p = SparePartSchema.safeParse(raw);
    return p.success ? p.data : null;
}
/** Deler under minimumsbeholdning (etterbestillingsliste), lavest dekning først. */
export function lowStockParts(parts) {
    return parts
        .filter((p) => p.qtyOnHand < p.qtyMin)
        .sort((a, b) => (a.qtyOnHand - a.qtyMin) - (b.qtyOnHand - b.qtyMin));
}
// ── Vedlikeholdslogg ─────────────────────────────────────────────────────────
export const MaintenanceKind = z.enum(['inspection', 'service', 'repair', 'fault']);
/** Materiellets driftstilstand etter en hendelse. */
export const EquipmentState = z.enum(['operational', 'limited', 'deadlined']);
export const EQUIPMENT_STATE_LABEL = {
    operational: 'Operativ', limited: 'Begrenset', deadlined: 'Ute av drift',
};
export const MaintenanceRecordSchema = z.object({
    id: z.string().max(64),
    equipmentId: z.string().max(64),
    kind: MaintenanceKind,
    /** Resulterende tilstand etter hendelsen. */
    state: EquipmentState.default('operational'),
    tsMs: z.number(),
    by: z.string().max(120).default(''),
    notes: z.string().max(4000).default(''),
    /** Deler brukt (part-id → antall). */
    partsUsed: z.record(z.string(), z.number().int().min(0)).default({}),
});
export function parseMaintenanceRecord(raw) {
    const p = MaintenanceRecordSchema.safeParse(raw);
    return p.success ? p.data : null;
}
/** Gjeldende tilstand for et materiell = seneste hendelse (etter tid). */
export function equipmentState(records, equipmentId) {
    const latest = records
        .filter((r) => r.equipmentId === equipmentId)
        .sort((a, b) => b.tsMs - a.tsMs)[0];
    return latest?.state ?? 'operational';
}
/** Materiell som er ute av drift (deadlined) — verste tilstand vinner per enhet. */
export function deadlinedEquipment(records) {
    const ids = [...new Set(records.map((r) => r.equipmentId))];
    return ids.filter((id) => equipmentState(records, id) === 'deadlined').sort();
}
/** Materiell-beredskap: andel operativt (til stridsevne-rollup). */
export function readinessRate(records) {
    const ids = [...new Set(records.map((r) => r.equipmentId))];
    if (!ids.length)
        return 1;
    const ok = ids.filter((id) => equipmentState(records, id) === 'operational').length;
    return ok / ids.length;
}
//# sourceMappingURL=maintenance.js.map